import { render, staticRenderFns } from "./PageUsers.vue?vue&type=template&id=91855588&scoped=true&"
import script from "./PageUsers.vue?vue&type=script&lang=ts&"
export * from "./PageUsers.vue?vue&type=script&lang=ts&"
import style0 from "./PageUsers.vue?vue&type=style&index=0&id=91855588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91855588",
  null
  
)

export default component.exports